import React from 'react'
import { MultiSelect } from 'primereact/multiselect'

const CustomMultiSelect = ({
  label,
  value,
  options,
  onChange,
  marginTop = 20,
  labelColor = '#14B0BF',
  showLabel = true,
  filter = true,
  filterPlaceholder = '',
  optionLabel = undefined,
  disabled = false,
  appendTo = undefined,
}) => {
  const styles = {
    container: { textAlign: 'left', marginTop },
    label: { fontSize: '0.8rem', color: labelColor, display: 'block' },
    multiselect: {
      outline: 'none',
      border: '1px solid #F1F1F1',
      borderRadius: 3,
      minWidth: '100%', // width: '100%',minWidth:'12em',
      marginTop: '3px',
    },
  }
  // Render
  return (
    <div style={styles.container}>
      {showLabel ? (
        <label style={styles.label} htmlFor="myInput">
          {label} &nbsp; :
        </label>
      ) : null}
      <MultiSelect
        style={styles.multiselect}
        value={value}
        optionLabel={optionLabel}
        options={options}
        filter={filter}
        disabled={disabled}
        selectedItemsLabel={'{0} Selecionados'}
        maxSelectedLabels={2}
        filterPlaceholder={filterPlaceholder}
        onChange={e => onChange(e.value)}
        appendTo={appendTo}
      />
    </div>
  )
}

export default CustomMultiSelect
